import React from 'react';
import { Link } from 'react-router-dom';
import { Project } from '../types';

interface ProjectCardProps {
  project: Project;
  compact?: boolean;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, compact = false }) => {
  const content = (
    <>
      <h2 className={compact ? 'atlas-project-title' : 'atlas-card-title'}>{project.title}</h2>
      <p>{project.description || 'Проект из инженерной практики.'}</p>
      <span className="atlas-status">{project.status === 'published' ? 'Опубликован' : 'В разработке'}</span>
      <span className="atlas-card-link">Подробнее <span aria-hidden="true">↗</span></span>
    </>
  );

  if (compact) {
    return <Link className="atlas-project-inner" to={`/projects/${project.slug}`}>{content}</Link>;
  }

  return <Link className="atlas-project-list-card" to={`/projects/${project.slug}`}>{content}</Link>;
};

export default ProjectCard;
